import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { SfaAttachmentContainerModel } from "../../../../../models/aggregates/sfa/deal/SfaDealAttachmentContainer.model";
import { ApiVisa, BasicApiResponseModel } from "../shared";
import { BaseApiTemplateService } from "../shared/base-api-template-service.model";
import { Core2Config } from "../shared/core2Config";

@Injectable({
    providedIn: 'root'
})
export class SfaAttachmentService extends BaseApiTemplateService<SfaAttachmentContainerModel> {

    readonly url = Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.SFA_MODULE_PREFIX + 'attachments';

    constructor(http: HttpClient) {
        super();
        this.apiUrl = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.SFA_MODULE_PREFIX + 'attachments';
        this.endpoint_path = Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.SFA_MODULE_PREFIX + 'attachments';
        this.httpClient = http;
    }

    getFile(attachmentGuid: string, visa: ApiVisa): Observable<Blob> {
        let url = this.apiUrl + '/download/' + attachmentGuid;
        if (this.endpoint_path && visa.api_domain_url) {
            url = visa.api_domain_url + this.endpoint_path + '/download/' + attachmentGuid;
        }
        return this.httpClient.get<Blob>(url, this.getHttpHeaderBlob(visa));
    }

    uploadFile(formData: FormData, type_guid: string,isDeal : boolean, visa: ApiVisa): Observable<BasicApiResponseModel<any>> {
        let url = this.apiUrl + "/upload/" + type_guid +"/"+ isDeal;
        if (this.endpoint_path && visa.api_domain_url) {
            url = visa.api_domain_url + this.endpoint_path + "/upload/" + type_guid +"/"+ isDeal;
        }
        return this.httpClient.post<BasicApiResponseModel<any>>(
            url,
            formData,
            this.getHttpHeader(visa)
        );
    }
    
    deleteFile(attachmentGuid:string,  visa: ApiVisa): Observable<BasicApiResponseModel<any>> {
        let url = this.apiUrl + "/delete/" + attachmentGuid ;
        if (this.endpoint_path && visa.api_domain_url) {
            url = visa.api_domain_url + this.endpoint_path + "/delete/" + attachmentGuid ;
        }
        return this.httpClient.delete<BasicApiResponseModel<any>>(
            url,
            this.getHttpHeader(visa)
        );
    }
}